<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="content-chapter1" id="_idParaDest-5"><span class="green"><a id="_idTextAnchor133"></a></span><a href="#/SustainableBadass4#_idTextAnchor002"><span class="green">Chapter 1 <br/><br/></span><span class="green CharOverride-11">The Plastic Problem<span id="_idTextAnchor134"></span></span><span class="CharOverride-11"> </span></a></p>
<p class="body_Special-Body_ChOp-Body"><span class="CharOverride-12">The first time I ever noticed the term “zero waste” was in an article about a woman from New York who could fit all her trash of three years into a single mason jar. I thought that sounded fascinating because I was making more trash than that just during an average day. That article started something in me, because I had never actually thought about my trash and where it ends up. Okay, I knew that it, of course, did not just disappear into thin air but that the trash pickup would take care of it and send it off to a local waste plant—so far so good. But I paid very little attention to my trash, and because of this, it felt like stepping into a completely new world when I started to find out what the problems with plastic actually are. So, I think it’s only fitting that this book will start in the same place that I started my own journey toward sustainability, and that is with the plasti</span><span class="noBreak CharOverride-12">c</span><span class="noBreak CharOverride-12"> </span><span class="noBreak CharOverride-12">problem.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SustainableBadass-7.vue?af079d8c